import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextRenin } from "./TextRenin";
import { SourcesRenin } from "./SourcesRenin";

export default function Renin() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};
    

return(
<>      
<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
           <TextCard 
            textcard={'Renin-Angiotensin-System' }
           />
</Button>

<CustomDialog open={open} onClose={handleClose}

        title='The Renin-Angiotensin-System (RAS) - Variants'

        content={<TextRenin />}

        sources={<SourcesRenin />}

    />

</>
)}